export enum KnaufPlaster {
    KnaufConniSBaranek,
    KnaufConniRKornik,
    KnaufKatiSBaranek,
    KnaufKatiRKornik,
    KnaufSP260Baranek,
    KnaufRP240Kornik,
    invalid
}
